import React, { FC, useCallback, useMemo } from 'react';
import { SelectOption } from '../Select';
import cn from 'classnames';
import classes from './Option.module.scss';

interface Props {
  className?: string;
  clickAction: (val: SelectOption) => void;
  option: SelectOption;
  selected: boolean;
}

const Option: FC<Props> = ({ className, clickAction, option, selected, children }) => {
  const onClickHandler = useCallback(() => {
    clickAction(option);
  }, [clickAction, option]);

  const optionClassNames = useMemo(() => {
    return cn(classes.element, selected && classes.selected, className);
  }, [className, selected]);

  return (
    <div onClick={onClickHandler} key={option.value} className={optionClassNames}>
      {children}
    </div>
  );
};

export default Option;
